import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

/**
 * Spanish labels for every mat-paginator.
 *
 * Material ships its own English strings and the app has no MatPaginatorIntl
 * provider, so a paginator reads "Items per page" / "1 – 10 of 42" in an
 * otherwise Spanish screen. Registered globally rather than per component
 * because there is already more than one paginator, and two of them in
 * different languages would be worse than the original English.
 */
@Injectable()
export class SpanishPaginatorIntl extends MatPaginatorIntl {
    override itemsPerPageLabel = 'Por página:';
    override nextPageLabel = 'Página siguiente';
    override previousPageLabel = 'Página anterior';
    override firstPageLabel = 'Primera página';
    override lastPageLabel = 'Última página';

    override getRangeLabel = (page: number, pageSize: number, length: number): string => {
        if (length === 0 || pageSize === 0) {
            return `0 de ${length}`;
        }

        const safeLength = Math.max(length, 0);
        const startIndex = page * pageSize;

        // A page beyond the end can be requested while a filtered result is
        // still loading; clamp so the label never reads past the total.
        const endIndex =
            startIndex < safeLength
                ? Math.min(startIndex + pageSize, safeLength)
                : startIndex + pageSize;

        return `${startIndex + 1} – ${endIndex} de ${safeLength}`;
    };
}
